import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpHeaders
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserService } from 'src/app/services/User.service';
import { TenantService } from 'src/app/services/tenant.service';
import { Capacitor } from '@capacitor/core';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private userService: UserService, private tenantService: TenantService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Get the token
    //const token = this.userService.getToken();
    // On native, the active profile's own token is the source of truth (each
    // profile has its own session); falls back to the global key right after
    // login before the profile upsert lands. Web always uses the global key.
    const token = Capacitor.isNativePlatform()
      ? (this.tenantService.getConfig()?.token ?? localStorage.getItem('token'))
      : localStorage.getItem('token');
    // Clone the request and add the Bearer token header if a token exists
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }
    // Clone the request and add additional headers
    const httpRequest = request.clone({
      setHeaders: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
      }
    });

    return next.handle(httpRequest);
  }
}
